export function trialErrorKey(error: unknown) {
  const message = error instanceof Error ? error.message : String(error)
  const keys = {
    trial_expired: "cowork.trial.error.expired",
    trial_project_limit: "cowork.trial.error.project",
    trial_storage_limit: "cowork.trial.error.storage",
    trial_chat_limit: "cowork.trial.error.chat",
    trial_message_limit: "cowork.trial.error.message",
  } as const
  return keys[message as keyof typeof keys]
}
